import { UseCustomAxios } from "../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../util/Utils";

export function UseAddOrder() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, setter) {
    let errorState = {
      firstName: isEmpty(state.firstName),
      lastName: isEmpty(state.lastName),
      provinceID: isEmpty(state.provinceID),
      cityID: isEmpty(state.cityID),
      address: isEmpty(state.address),
      mobile: isEmpty(state.mobile),
      paymentType: isEmpty(state.paymentType),
      deliveryID: isEmpty(state.deliveryID),
      deliveryType: isEmpty(state.deliveryType),
    };

    setter(errorState);

    if (
      errorState.firstName ||
      errorState.lastName ||
      errorState.provinceID ||
      errorState.cityID ||
      errorState.address ||
      errorState.mobile ||
      errorState.paymentType ||
      errorState.deliveryType ||
      errorState.deliveryID
    ) {
      enqueueSnackbar("لطفا اطلاعات را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetProductsByWord = (search, callback) => {
    MyAxios.get(`Admin_NewOrder/GetProductsByWord?w=${search}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const GetUserInfo = (Mobile, callback) => {
    MyAxios.get(`Admin_NewOrder/GetUserInfo/${Mobile}`).then((response) => {
      callback(response.data.resault);
    });
  };

  const getOrdersLoc = (orderID, callback) => {
    MyAxios.get(`Admin_Orders/AdminOrder_Info/${orderID}`).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };
  const GetExpressDeliveryCost = (orderID, state, callback) => {
    MyAxios.get(
      `Admin_Orders/AdminOrder_ExpressDelivery/${orderID}/${state.latitude}/${state.longitude}`
    ).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  const getByOrderID = (OrderID, callback) => {
    MyAxios.get(`Admin_NewOrder/Clone/${OrderID}`, {
      headers: {
        IsPage: true,
      },
    }).then((response) => {
      if (response && response.data && response.data.state == 200) {
        callback(response.data.resault);
      }
    });
  };

  // const getOrderByID = (id, callback) => {
  //   MyAxios.get(`Admin_Orders/${id}`, {
  //     headers: {
  //       Conditions: JSON.stringify({
  //         pageCondition: {
  //           page: 1,
  //           sortColumn: "Id",
  //           sortOrder: "Asc",
  //           searchText: "",
  //           scrollTo: undefined,
  //           forceRefresh: false,
  //         },
  //       }),
  //     },
  //   }).then((response) => {
  //     if (response && response.data && response.data.state == 200) {
  //       callback(response.data.resault);
  //     }
  //   });
  // };

  const AddToOrder = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_NewOrder/AddToOrder`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("با موفقیت به سبد خرید اضافه شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const RemoveOrder = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_NewOrder/RemoveOrder`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("محصول با موفقیت حذف شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const AddDiscountCode = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_NewOrder/AddDiscountCode`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("کد تخفیف اعمال شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const CheckOrder = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_NewOrder/CheckOrder`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("سفارش محاسبه گردید", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  const SaveOrder = (state, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    MyAxios.post(`Admin_NewOrder/SaveOrder`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("سفارش با موفقیت ثبت شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback(response.data.resault);
      }
    });
  };

  return {
    AddToOrder,
    GetProductsByWord,
    // getOrderByID,
    validate,
    getOrdersLoc,
    RemoveOrder,
    AddDiscountCode,
    CheckOrder,
    getByOrderID,
    GetUserInfo,
    SaveOrder,
    GetExpressDeliveryCost,
  };
}
